import React, { useEffect, useState } from 'react'
import { TreeSelect } from 'antd';
import { TREE_DATA_JSON } from '../constants/Constant';
const { SHOW_ALL } = TreeSelect;


const NarbarSearchDropdown = (props) => {
    const [treedata, setTreeData] = useState();

    useEffect(() => {
        // setTreeData(TREE_DATA_JSON);
        setTreeData(props.tabcriteria);
    }, [props.tabcriteria])

    const findChild = (updatedTreedata, newValue) => {
        let result;
        updatedTreedata.some(
            (child) =>
                (child.key === newValue && (result = child)) ||
                (result = findChild(child.children || [], newValue))
        );
        return result;
    };

    const onChange = (newValue) => {
        props.setSearchDropDownFilter(newValue)
    };

    let tProps = {
        treeData: treedata,
        treeDefaultExpandAll: true,
        value: props.defaultSelectedOnLoad,
        onChange,
        showCheckedStrategy: SHOW_ALL,
        placeholder: 'Please select',
        style: {
            width: '100%',
        },
        multiple: false,
        // checkStrictly: true,
        popupClassName: "treeselect-dropdown-align"



    };
    return (
        <TreeSelect
            {...tProps}
        />
    )
}

export default NarbarSearchDropdown;
